import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import RelatedTransaction from './RelatedTransaction';
import relatedTransactionsArray from './RelatedTransactionArray';

const emptyProps = {
  case_uuid: 'azbtest_2644',
  purchase_right_away: false,
  transactions: [],
  noDataFoundMessage: 'There are no transactions.',
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  currentUser: '1',
  docketParts:{
    alreadyPurchased: false,
    errors: null,
    parts: 0,
    partsToPurchase: 0,
    percentage: 0,
    purchased: 0,
    status: "loading",
    step: 0,
    totalCost: 0,
  },
  tableSortProps:{
    sort_direction: "desc",
    sort_field: "date_event_filed",
  },
  relatedTransactionEntriesProps: {
    buyPdf: () => action('buyPdf'),
    case_uuid: "azbtest_2644",
    sortRelatedTransaction :() => action('sortRelatedTransaction'),
    entries: [],
    selectedDocketDetailNum: null,
    showRedactPopup: undefined,
    transactions: {total_items: 56, page_size: 500, total_pages: 0.112, entries: []},
  },
  relatedTransactionPaginatorProps:{
    case_uuid: "azbtest_2644",
    changePage: () => action('changePage'),
    selectedPageNum: 1,
    transactions: {total_items: 56, page_size: 500, total_pages: 0.112, entries: []},
  },
  transactions: [],
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
  sidebarData: {},
  kloudless: {},
};

const sampleRelatedTransactionsProps = {
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  currentUser: '1',
  docketParts:{
    alreadyPurchased: false,
    errors: null,
    parts: 0,
    partsToPurchase: 0,
    percentage: 0,
    purchased: 0,
    status: "loading",
    step: 0,
    totalCost: 0,
  },
  tableSortProps:{
    sort_direction: "desc",
    sort_field: "date_event_filed",
  },
  relatedTransactionEntriesProps: {
    buyPdf: () => action('buyPdf'),
    getDocketDetails: () => action('getDocketDetails'),
    case_uuid: "azbtest_2644",
    sortRelatedTransaction :() => action('sortRelatedTransaction'),
    entries: relatedTransactionsArray,
    selectedDocketDetailNum: null,
    showRedactPopup: undefined,
    transactions: {total_items: 56, page_size: 500, total_pages: 0.112, entries: relatedTransactionsArray},
  },
  relatedTransactionPaginatorProps:{
    case_uuid: "azbtest_2644",
    changePage: () => action('changePage'),
    selectedPageNum: 1,
    transactions: {total_items: 56, page_size: 500, total_pages: 0.112, entries: relatedTransactionsArray},
  },
  transactions: relatedTransactionsArray,
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
  sidebarData: {},
  kloudless: {},
};


const docketPartsProps = {
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  currentUser: '1',
  docketParts:{
    alreadyPurchased: false,
    errors: null,
    parts: 0,
    partsToPurchase: 0,
    percentage: 0,
    purchased: 0,
    status: "loading",
    step: 0,
    totalCost: 0,
  },
  tableSortProps:{
    sort_direction: "desc",
    sort_field: "date_event_filed",
  },
  selectedDocket:{
    seqNum: 940,
    status: "done",
  },
  relatedTransactionEntriesProps: {
    buyPdf: () => action('buyPdf'),
    getDocketDetails: () => action('getDocketDetails'),
    case_uuid: "azbtest_2644",
    onPopupClick: () => action('onPopupClick'),
    sortRelatedTransaction: () => action('sortRelatedTransaction'),
    entries: relatedTransactionsArray,
    selectedDocketDetailNum: 940,
    showRedactPopup: undefined,
    transactions: {
      total_items: 56,
      page_size: 500,
      total_pages: 0.112,
      entries: relatedTransactionsArray,
      docketDetails: {
        details: [
          {
            action: "https://ecf-test.azb.uscourts.gov/doc2/024140168?caseid=2644",
            case_uuid: "azbtest_2644",
            cost: "0.00",
            create_blog_post_url: "/create-pleadings-blog-post/azbtest_2644/41/1/20ee507ef3952d8b3f69d5ba067c5972",
            description_html: null,
            docket_no: "940",
            download_ocr_uri: "/ir-documentselect/download_ocr/azbtest_2644/41/1",
            download_url: "/ir-documentselect/download_pdf/docket/azbtest_2644/41/1",
            filename: "Bankr.D.Ariz.TEST_2-07-bk-00012_41.pdf",
            free: null,
            friendly_name: "Bankr.D.Ariz.TEST_2-07-bk-00012_41.pdf",
            number: 1,
            ocr_link: "http://aws-s3.inforuptcy.dev.azk.io/inforuptcy-storage/pacer-ocr/pacer/azbtest/2644/dockets/41/1-9E5150F4-947D-11E9-A6D5-ACACFDDFD522.txt?response-content-disposition=attachment%3B+filename%3DBankr.D.Ariz.TEST_2-07-bk-00012_41.pdf.txt&AWSAccessKeyId=dummy_aws_access_key&Expires=1877043966&Signature=afwEpHhb5B7kogO6VhWjpMsGkLA%3D",
            pages: "1",
            public_pdf_link: "http://aws-s3.courtdrive.inforuptcy.dev.azk.io/inforuptcy-storage/pacer/azbtest/2644/dockets/41/1-9E5150F4-947D-11E9-A6D5-ACACFDDFD522",
            raw_location: "s3://inforuptcy-storage/pacer/azbtest/2644/dockets/41/1-9E5150F4-947D-11E9-A6D5-ACACFDDFD522",
            sequence_number: "940.00000",
          },
        ],
        seqNum: 940}},
  },
  relatedTransactionPaginatorProps:{
    case_uuid: "azbtest_2644",
    changePage: () => action('changePage'),
    selectedPageNum: 1,
    transactions: {total_items: 56, page_size: 500, total_pages: 0.112, entries: relatedTransactionsArray},
  },
  transactions: relatedTransactionsArray,
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
  visibleDocketRow: "0-0",
  sidebarData: {},
  kloudless: {},
};

storiesOf('Case Menu/Related Transactions', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr />
      <RelatedTransaction />
    </div>
  ))

  .add('View', () => (
    <div>
      <h3>By default, we show a list of transactions received form the parser API</h3>
      <hr />
      <h4>Page contains 'Find What' input that searches through table of data.</h4>
      <h4>There is 'Premium Search' button, which leads to the premium search url.</h4>
      <h4>Show/Hide 'Pacer filter' display/hide pacer filter section, that searches transactions from pacer api.</h4>
      <h4>If transactions are available 'Parser filter' section, that searches transactions from parser api.</h4>
      <hr />

      <RelatedTransaction
        {...sampleRelatedTransactionsProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ))
  .add('View Docket Details', () => (
    <div>
      <h3>On click docket number Docket Details row is being displayed</h3>
      <hr />
      <RelatedTransaction
        {...docketPartsProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ))
  .add('No Data', () => (
    <div>
      <h3>If there is no data found, message is displayed.</h3>
      <hr />
      <h4>We can refresh list by clicking the 'Update from Pacer' button</h4>
      <hr />

      <RelatedTransaction {...emptyProps} />
    </div>
  ));




// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransaction.stories.jsx